import { CONTAINER_ID_PREFIX, HANDLE_ID, SESSION_CONTAINER_HEIGHT } from './constants';
import { findTouchById } from './helpers';
import { resetAnimationBubble } from './configureLogoBubble';

export const insertContainerHandle = (containerId: string, iframeId: string) => {
  const container = document.getElementById(containerId)!;
  const iframe = document.getElementById(iframeId)!;

  const handle = document.createElement('div');
  handle.id = HANDLE_ID;
  const handleStyle = `
      width: 100%;
      height: 16px;
      top: -8px;
      background: transparent;
      cursor:ns-resize;
      position: absolute;
    `;
  handle.setAttribute('style', handleStyle);
  container.appendChild(handle);

  // Global styles
  const style = document.createElement('style');
  container.appendChild(style);
  const { sheet } = style;
  const htmlDraggingClass = `${CONTAINER_ID_PREFIX}html-dragging`;
  const bodyDraggingClass = `${CONTAINER_ID_PREFIX}body-dragging`;
  sheet!.insertRule(`
      .${htmlDraggingClass} {
        cursor: row-resize !important;
      }
    `);
  sheet!.insertRule(`
      .${bodyDraggingClass} {
        user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        pointer-events: none;
        touch-action: none;
      }
    `);

  const setDraggingStyles = () => {
    const { body, documentElement: html } = document;
    // Set dragging styles (remove select, pointer events modify cursor globaly)
    handle.style.cursor = 'row-resize';
    html.classList.add(htmlDraggingClass);
    body.classList.add(bodyDraggingClass);
    iframe.classList.add(htmlDraggingClass, bodyDraggingClass);
  };

  const resetDraggingStyles = () => {
    const { body, documentElement: html } = document;
    // Reset dragging styles
    handle.style.cursor = 'ns-resize';
    html.classList.remove(htmlDraggingClass);
    body.classList.remove(bodyDraggingClass);
    iframe.classList.remove(htmlDraggingClass, bodyDraggingClass);
    sessionStorage.setItem(SESSION_CONTAINER_HEIGHT, `${container.clientHeight}px`);
  };

  const resizeContainer = (
    originalContainerHeight: number,
    orignalPointerPositionY: number,
    pointerPositionY: number
  ) => {
    const verticalVariationPointerPosition = orignalPointerPositionY - pointerPositionY;
    const newContainerHeight = originalContainerHeight + verticalVariationPointerPosition;
    container.style.height = `${newContainerHeight}px`;
  };

  // Vertical resizer handler (adapted from https://github.com/phuoc-ng/html-dom/blob/master/demo/create-resizable-split-views/direction.html)
  const mouseDownHandler = (e: MouseEvent) => {
    const orignalMousePositionY = e.clientY;
    const originalContainerHeight = container.clientHeight;

    const mouseMoveHandler = (e: MouseEvent) => {
      const mousePositionY = e.clientY;
      resizeContainer(originalContainerHeight, orignalMousePositionY, mousePositionY);
      setDraggingStyles();
    };

    const mouseUpHandler = () => {
      resetDraggingStyles();
      resetAnimationBubble();
      // Clean the mouse listeners
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    // Attach the mouse listeners
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  };
  // Attach mouse down listener
  handle.addEventListener('mousedown', mouseDownHandler);

  const touchStartHandler = (e: TouchEvent) => {
    e.preventDefault();

    const originalContainerHeight = container.clientHeight;

    const { identifier, clientY: orignalTouchPositionY } = e.targetTouches[0];

    const touchMoveHandler = (e: TouchEvent) => {
      const touch = findTouchById(e.changedTouches, identifier);
      if (touch) {
        const touchPositionY = touch.clientY;
        resizeContainer(originalContainerHeight, orignalTouchPositionY, touchPositionY);
        setDraggingStyles();
      }
    };

    const touchEndHandler = () => {
      const touch = findTouchById(e.changedTouches, identifier);
      if (touch) {
        resetDraggingStyles();
        resetAnimationBubble();
        // Clean the touch listeners
        document.removeEventListener('touchmove', touchMoveHandler);
        document.removeEventListener('touchend', touchEndHandler);
      }
    };

    // Attach the touch listeners
    document.addEventListener('touchmove', touchMoveHandler);
    document.addEventListener('touchend', touchEndHandler);
  };
  // Attach touch start listener
  handle.addEventListener('touchstart', touchStartHandler);
};
